<template>
    <el-select clearable v-model="data" :placeholder="$t('请选择')" @change="handleChange">
                    <el-option :label="$t('温州移动')" value="温州移动"></el-option>
                    <el-option :label="$t('中点物联')" value="中点物联"></el-option>
                    <el-option :label="$t('量讯')" value="量讯"></el-option>
                    <el-option :label="$t('旭宇')" value="旭宇"></el-option>
                    <el-option :label="$t('红豆电信')" value="红豆电信"></el-option>
            </el-select>
</template>
<script>
export default {
    name:"supplierSelect",
    data(){
        return{
            data:""
        }
    },
    props:["value"],
    watch:{
        value:{
            immediate: true,
            handler(value) {
                if (!value) {
                    this.data="";
                    this.$emit("input",value)
                } else{
                     this.data=value;
                }
            }
        }
    },
    methods:{
        handleChange(value){
            this.$emit("input",value)
            this.data=value;
      },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/supplierSelect/index.vue